export const version = {
  timeStamp: '2026-07-14 12:45:34 PM ',
  version: '0.0.5',
};
